import { orange } from '../orange';

export const high = {
  primary: orange[600],
  500: orange[500],
  400: 'hsla(270, 50%, 74%, 1)',
  300: 'hsla(270, 50%, 80%, 1)',
  200: 'hsla(270, 50%, 86%, 1)',
  100: orange[100],
  50: orange[50],
  30: 'hsla(270, 50%, 94%, 0.5)',
};
